import cx from "clsx";
import type React from "react";
import type { ReactNode } from "react";
import { useDropdownContext } from "~/components/common/parts/dropdown/Dropdown";
import Styles from "./DropdownMenu.module.scss";

type Props = {
	children: ReactNode;
	className?: string;
	onClick: () => void | Promise<void> | boolean | Promise<boolean>;
};

export const DropdownMenu: React.FC<Props> = ({
	children,
	className = "",
	onClick
}: Props) => {
	const { setShow } = useDropdownContext();
	const onClickMenu = async (e: React.MouseEvent): Promise<void> => {
		e.preventDefault();
		// Router.push等でComponentがDestructされる場合はtrueを返してもらう
		const notNeedRestore = await onClick();
		if (notNeedRestore !== true) {
			setShow?.(false);
		}
	};
	return (
		<div className={cx(Styles.DropdownMenu, className)}>
			<a className={Styles.DropdownMenuLink} href="#" onClick={onClickMenu}>
				{children}
			</a>
		</div>
	);
};
